import { render, staticRenderFns } from "./ManageCustomersPage.vue?vue&type=template&id=ddc5919e&scoped=true&"
import script from "./ManageCustomersPage.vue?vue&type=script&lang=js&"
export * from "./ManageCustomersPage.vue?vue&type=script&lang=js&"
import style0 from "./ManageCustomersPage.vue?vue&type=style&index=0&id=ddc5919e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddc5919e",
  null
  
)

export default component.exports